export const isMasterUser = (user: any): boolean => {
  if (!user || typeof user !== "object") return false;

  if (user.isMaster === true) return true;
  if (user.is_master === true) return true;
  if (user.rbac?.isMaster === true) return true;

  const roleEntries: any[] = [
    ...(Array.isArray(user.roles) ? user.roles : []),
    ...(Array.isArray(user.rbac?.roles) ? user.rbac.roles : []),
    ...(user.role ? [user.role] : []),
  ];

  return roleEntries.some((role: any) => {
    if (typeof role === "string") {
      return role.toUpperCase().includes("MASTER");
    }

    const key = String(role?.key ?? "").toUpperCase();
    const name = String(role?.name ?? "").toUpperCase();
    return key.includes("MASTER") || name.includes("MASTER");
  });
};

export const filterOutMasterUsers = <T = any>(users: T[] | undefined | null): T[] => {
  if (!Array.isArray(users)) return [];
  return users.filter((user: any) => !isMasterUser(user));
};
